import {
  QueryClient,
  QueryClientProvider as ReactQueryClientProvider,
} from "@tanstack/react-query";
import { useEffect } from "react";
import { subscribeRpcMutations } from "@/lib/rpc-sync";
import { refreshRpcQueries } from "@/lib/rpc-refresh";

const queryClient = new QueryClient();

export function QueryClientProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(
    () =>
      subscribeRpcMutations(() => {
        refreshRpcQueries(queryClient);
      }),
    [],
  );
  return (
    <ReactQueryClientProvider client={queryClient}>
      {children}
    </ReactQueryClientProvider>
  );
}
